import Header from '../../components/Header'
import Banner from '../../components/Banner'
import Footer from '../../components/Footer'
import RestaurantList from '../../components/RestaurantList'

const Home = () => (
  <>
    <Header />
    <Banner />
    <RestaurantList />
    <Footer />
  </>
)

export default Home
